import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container } from "./styles";
import { Greetings } from "./components/greetings";

import {
  getMediaKitImages,
  getUserHasAccess,
} from "../../redux/modules/AI_Creator/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export function AI_Creator() {
  const dispatch = useDispatch();
  const { hasAccess, mediaKit, unlimitedImages } = useSelector(
    (state) => state.ai_creator,
  );
  const { contract } = useSelector((state) => state.initialSettings);

  const history = useHistory();

  useEffect(() => {
    dispatch(getUserHasAccess());
    dispatch(getMediaKitImages());
  }, [dispatch, contract?.value]);

  useEffect(() => {
    if (mediaKit.length > 0) history.push("/ai-creator/media-kit");
  }, [history, mediaKit.length]);

  return (
    <Container>
      <Greetings hasAccess={hasAccess} />
    </Container>
  );
}
